import { readonly, ref } from 'vue'

import { isMobileAvatarClient } from '../utils/mobile-avatar-guard'

const open = ref(false)

export function useDesktopAvatarNotice() {
  const show = () => {
    open.value = true
  }
  const close = () => {
    open.value = false
  }
  const blockOnMobile = () => {
    if (!isMobileAvatarClient())
      return false
    show()
    return true
  }
  return { open: readonly(open), show, close, blockOnMobile }
}
